import { gql } from '@apollo/client';

export const GET_WORKSHIFT_DATA = gql`
  query workshiftData {
    getWorkShiftPaymentOverviewData {
      id
      total
      cash
      card
      deposit
      online_deposit
      bonus
      cash_on_start
      created_at
      sum {
        good
        service
        tariff
        deposit
        tips
      }
      cash_orders {
        type
        comment
        created_at
        sum
      }
      worker {
        uuid
        first_name
        last_name
      }
      goods {
        title
        cost
        amount
        in_stock
        sum
      }
      services {
        title
        amount
        sum
      }
      combos {
        title
        amount
        sum
      }
    }

    activeWorkShift {
      payments {
        method
        status
      }
    }
  }
`;
